<script lang="ts">
  import { Col, Container, Row, Table } from "sveltestrap";
  import BookmarkCart from "./BookmarkCart.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Cart } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import CartData from "./CartData.svelte";
  import CartTableBody from "./CartTableBody.svelte";

</script>
<BookmarkCart />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card headerTitle={Cart} cardHeaderprops="pb-0">
        <div slot="contentbody">
          <Row>
            <div class="order-history table-responsive wishlist">
              <Table bordered>
                <thead>
                  <tr>
                    {#each data.carttableheaderdata as header}
                      <th>{header.title}</th>
                    {/each}
                  </tr>
                </thead>
                <tbody>
                  <CartData />
                  <CartTableBody  />
                </tbody>
              </Table>
            </div>
          </Row>
        </div>
      </Card>
    </Col>
  </Row>
</Container>